document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartItems', () => {
    return {
      itemsRoot: null,
      locked: null,
      init() {
        this.itemsRoot = this.$root;

        window.addEventListener('cascade:modalcart:afteradditem', (e) => {
          // Safety check: Ensure sections exist in response
          if (!e.detail?.response?.sections?.['cart-items']) {
            console.warn('⚠️ cart-items: No sections in afteradditem response, skipping morph');
            return;
          }

          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections['cart-items']
            ).outerHTML
          );
        });

        window.addEventListener('cascade:modalcart:cartqtychange', (e) => {
          // Safety check: Ensure sections exist in response
          if (!e.detail?.response?.sections?.['cart-items']) {
            console.warn('⚠️ cart-items: No sections in response, skipping morph');
            return;
          }

          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections['cart-items']
            ).outerHTML
          );

          this.$nextTick(() => {
            this.itemsRoot.querySelectorAll('input').forEach((inputEl) => {
              inputEl.value = inputEl.getAttribute('value');
            });
          });

          const liveRegionText = parseDOMFromString(
            e.detail.response.sections['cart-live-region']
          ).firstElementChild.textContent;

          const cartStatus = document.getElementById('cart-live-region-text');

          cartStatus.textContent = liveRegionText;

          cartStatus.setAttribute('aria-hidden', false);

          setTimeout(() => {
            cartStatus.setAttribute('aria-hidden', true);
          }, 1000);

          if (e.detail.originalTarget) {
            this.$nextTick(() => {
              if (!this.itemsRoot.contains(e.detail.originalTarget)) {
                let focusRoot;

                if (this.itemsRoot.closest('[role="dialog"]')) {
                  focusRoot =
                    this.itemsRoot.closest('[role="dialog"]').parentNode;
                } else {
                  focusRoot = this.itemsRoot;
                }

                this.$focus.within(focusRoot).first();
              }
            });
          }
        });
      },
      itemQuantityChange(key, value) {
        if (this.locked) return;

        const lineItemEl = this.$el.closest('li[data-cart-item-key]');
        const id = key ? key : lineItemEl.getAttribute('data-cart-item-key'),
          quantity = parseInt(!isNaN(value) ? value : this.$el.value, 10);

        const config = fetchConfigDefaults('javascript');

        config.body = JSON.stringify({
          id,
          quantity
        });

        const lastValue = parseInt(this.$el.dataset.lastValue, 10);

        if (quantity !== lastValue) {
          lineItemEl.classList.add('opacity-50', 'cursor-progress');

          const currentCount = Alpine.raw(Alpine.store('cart_count').count);

          this.locked = lineItemEl;

          // First, change the cart item quantity
          fetch(theme.routes.cart_change_url + '.js', config)
            .then((res) => res.json())
            .then((data) => {
              if (data.status === 422) {
                const errorEl = lineItemEl.querySelector(
                  '[data-cart-quantity-error]'
                );

                errorEl.textContent = data.message;

                errorEl.classList.remove('hidden');
                lineItemEl.classList.remove('opacity-50', 'cursor-progress');

                this.$el.value = lastValue;
              } else {
                // After successful change, fetch sections separately
                const sections = 'cart-items,cart-footer,cart-item-count,cart-live-region';

                return fetch(`/?sections=${sections}`)
                  .then(r => r.json())
                  .then(sectionsData => {
                    // Merge sections into response
                    data.sections = sectionsData;

                    document.body.dispatchEvent(
                      new CustomEvent('cascade:modalcart:cartqtychange', {
                        bubbles: true,
                        detail: { response: data, originalTarget: lineItemEl },
                      })
                    );
                  });
              }
            })
            .catch(() => {
              document.getElementById('cart-errors').textContent =
                theme.strings.cartError;
            })
            .finally(() => {
              this.locked = null;
            });
        }
      },
      removeItem(key) {
        this.itemQuantityChange(key, 0);
      },
      _adjustQty(el, operation) {
        const liEl = el.closest('li[data-cart-item-key]');

        if (!liEl) {
          console.error('Could not find li[data-cart-item-key] element');
          return;
        }

        const inputEl = liEl.querySelector('input[type="number"]');

        // For items without input (e.g., reward items), handle remove directly
        if (!inputEl && operation === 'remove') {
          const key = liEl.getAttribute('data-cart-item-key');
          if (key) {
            console.log('Removing item without input:', key);
            this.itemQuantityChange(key, 0);
          }
          return;
        }

        if (!inputEl) {
          console.error('Could not find input element');
          return;
        }

        const lastValue = parseInt(inputEl.dataset.lastValue, 10);

        let newValue;

        if (operation == 'increment') {
          newValue = lastValue + 1;
        }

        if (operation == 'decrement') {
          if (lastValue > 1) {
            newValue = lastValue - 1;
          } else {
            newValue = 1;
          }
        }

        if (operation == 'remove') {
          newValue = 0;
        }

        inputEl.value = newValue;

        // this.$nextTick(() => {
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
        // });
      },
      increment() {
        this._adjustQty(this.$el, 'increment');
      },
      decrement() {
        this._adjustQty(this.$el, 'decrement');
      },
      remove(event) {
        // If called from a link, find the closest li[key] element
        const target = event?.target || this.$el;
        this._adjustQty(target, 'remove');
      },
    };
  });
});
